import { Dialog, DialogTitle, DialogContent, Typography, Grid, Chip, Avatar, IconButton, DialogActions, Button } from "@mui/material";
import React, { useState } from "react";
import moment from 'moment';
import AttachmentIcon from '@mui/icons-material/Attachment';
import { Class, Close, Create, Download, Language } from "@mui/icons-material";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LinkIcon from '@mui/icons-material/Link';
import { TimeConversion } from '../../../utils/TimeConversion';
import * as XLSX from 'xlsx';

function ExternalAttendeesModal(props) {
    const [open, setOpen] = React.useState(false);
    const [downloading,setDownloading] = useState(false);
    const handleClose = () => {
        setOpen(false);
        props.handleAttendees();
    }
    React.useEffect(() => {
        if (props.open) {
            setOpen(true)
        }
    }, [props])
    const formatDate = (date) => {
        return moment(date).format('MMM-DD-YYYY');
    }

    const downloadFile = (filename) => {
        window.location.href = `/api/uploads/file/download/${filename}`
    }
    console.log(props)
    const BootstrapDialogTitle = (props) => {
        const { children, onClose, ...other } = props;

        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                {children}
                {handleClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                ) : null}
            </DialogTitle>
        );
    };

    const handleDownload =(file)=> {
        fetch(`/api/uploads/file/download/${file}`).then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = props.data.actualFileName;
                alink.click();
            })
        })
    }

    const exportData = () => {
        setDownloading(true)
        const result = props.users.map(({ id, departmentCode, image,trainerComment, ...rest }) => {
            return rest;
        });
        let date = TimeConversion(props.data.startDate, 0);
        let title = props.data.title + "_" + date;

        let header = ["Employee Code", "First Name", "Last Name", "Email Address", "Phone Number", "Department Name", "Team Name", "Designation"];
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.sheet_add_json(ws, result, { origin: 'A2', skipHeader: true });
        XLSX.utils.sheet_add_aoa(ws, [header]);
        XLSX.utils.book_append_sheet(wb, ws, "attendees list");
        XLSX.writeFileXLSX(wb, `${title}.xlsx`);
        setDownloading(false)
    }
    return (
        <div>
            <Dialog
                fullWidth="md"
                maxWidth="md"
                open={open}
                onClose={handleClose}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <BootstrapDialogTitle id="scroll-dialog-title">
                    <Typography id="modal-modal-title" className='modal-heading' variant="h6" component="h2">
                        {props.data.title}
                    </Typography></BootstrapDialogTitle>
                <DialogContent dividers>
                    <Grid container>
                        <Grid item xs={12}>
                            <p className="external-desc">{props.data.description !== null && props.data.description !== "" ? props.data.description : "Description not available"}</p>
                            <p className="external-desc" style={{ fontWeight: "bold" }}><CalendarTodayIcon fontSize='small' className="icon" /> {formatDate(props.data.startDate)}-{formatDate(props.data.endDate)}</p>
                            {props.from === "all"? props.createrName !== null && props.createrName !== ""?<p className="external-desc" style={{ fontWeight: "bold" }}><Create fontSize='small' className="icon"/>Created by: {props.data.createrName}</p>:"":""}
                            {props.data.referenceUrl !== null && props.data.referenceUrl !== "" ? <p className="external-desc" style={{ fontWeight: "bold" }}>
                                <LinkIcon fontSize='small' className="icon" /> 
                            <a href={props.data.referenceUrl !== "" ? props.data.referenceUrl : ""} target="_blank">{props.data.referenceUrl}</a></p>
                            : "Reference url not available"}
                            {props.data.externalTrainingType !== null && props.data.externalTrainingType !== "" ?
                                <p className="external-desc">
                                    <span className='level-text stensil'>{props.data.externalTrainingType === "Online" ? <Language /> : <Class />} {props.data.externalTrainingType} </span>
                                </p> : ""}
                            {props.data.externalTrainerName !== null && props.data.externalTrainerName !== "" ?
                                <p className="external-desc">
                                    <span><small style={{ fontWeight: "bold", fontSize: "14px" }}>Trainer:</small> {props.data.externalTrainerName}</span>
                                </p>
                                : ""}
                            {props.data.actualFileName !== "" ?
                            <div><Chip icon={<Download />} label={props.data.actualFileName} onClick={()=>handleDownload(props.data.physicalFileName)}/></div>
                            //    <div><Download /> <a href={`/api/uploads/file/download/${props.data.physicalFileName}`}>{props.data.actualFileName}</a> </div>
                                : ""}
                            {props.from !== "mylist" && props.users.length > 0 ?
                                <>
                                    <p className="external-desc">Attended by:</p>
                                    {props.users.map((user) => {
                                        return <Chip sx={{ marginRight: "10px" }} color="primary" variant="outlined"
                                            avatar={<Avatar alt={user.firstName} src="/static/images/avatar/1.jpg" />}
                                            label={user.firstName +" "+ user.lastName} />
                                    })}
                                </> : ""}

                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions dividers>
                    {props.from !== "mylist" && props.users.length > 0?
                    downloading?
                    <Button className='theme-btn all-down' variant='contained' startIcon={<Download />} disabled={true}>Downloading...</Button>
                    :<Button className='theme-btn all-down' variant='contained' onClick={() => exportData()}>Download Attendees</Button>:""}
                    <Button className="theme-btn cancel-btn" variant="contained" onClick={() => handleClose()}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default ExternalAttendeesModal;